import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { summarizeQueue, type TaskRow } from '../lib/fleet';

// The queue board's count band (#513): running vs queued at a glance, derived
// from the rows on screen (by `lifecycle_bucket`), so the numbers can never
// disagree with the list below them. Terminal rows (succeeded/failed) count in
// neither lane — the band is about work in motion. Presenter: the FleetQueuePanel
// hands it the already-blended live rows.

export function FleetQueueBand(props: { readonly rows: readonly TaskRow[] }): JSX.Element {
  const counts = () => summarizeQueue(props.rows);
  return (
    <ul class="metric-grid" aria-label={t('fleet.band_aria')} data-testid="queue-band">
      <li class="card" data-state="online">
        <div class="card__content">
          <p class="metric-grid__label">{t('fleet.band_running')}</p>
          <p class="metric-grid__value">{counts().running}</p>
        </div>
      </li>
      <li class="card" data-state="pending">
        <div class="card__content">
          <p class="metric-grid__label">{t('fleet.band_queued')}</p>
          {/* server depth = the full pending backlog (accurate above the row cap);
              fall back to the on-screen count for pre-#513 rows that carry no depth. */}
          <p class="metric-grid__value">{counts().depth ?? counts().queued}</p>
        </div>
      </li>
    </ul>
  );
}
